import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  background-color: #fff;
  color: #333;
  border-radius: 8px;
  padding: 5px 20px;
  box-shadow: 0 0 15px #dcdcdc;
  font-family: Komet;
  margin-top: 20px;
`;

export const Row = styled.div`
  margin: 20px 0;

  ${mediaMaxWidth.smallDesktop`
    margin: 0;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d2d2d2;
  padding: 0 0 5px 0;
  font-weight: 600;
  display: flex;

  ${mediaMaxWidth.smallDesktop`
    display: unset;
    width: 40%;
    float: left;
    border-bottom: none;
    padding: 0;
    line-height: 2em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: .95em;
  `}
`;

export const TitleItem = styled.div`
  min-width: 110px;
  flex: 1;
`;

export const Inner = styled.div`
  font-size: 1.7em;
  padding: 15px 0 5px 0;
  display: flex;

  ${mediaMaxWidth.smallDesktop`
    display: unset;
    width: 50%;
    float: right;
    font-size: 1em;
    padding: 0;
    line-height: 2em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: .95em;
    width: 45%;
  `}
`;

export const InnerItem = styled.div`
  flex: 1;
`;
